import SearchBar from "./index.vue";

// SearchBar.install = Vue => Vue.component(SearchBar.componentName, SearchBar);

export default SearchBar;
